<template>
  <div class="user-container">
    <div class="toggle-btn" @click="bindToggle"
      ><img class="hide-icon" :src="getHideIcon(hideData)" alt="" /><span>{{
        hideData ? '显示数据' : '隐藏数据'
      }}</span></div
    >
    <img
      class="project-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/f506480e3bb6c9be73483cac4c2fa4be_wh=228_48.webp"
      alt=""
    />
    <!-- 用户信息 -->
    <div class="user-info">
      <img class="avatar" :src="info.image" alt="" />
      <div class="user-right">
        <div class="truename">{{ info.truename }}</div>
        <div class="user-desc"
          >{{ activityStatusText }}，<span class="bold" @click="bindPreview"
            >查看挑战书></span
          ></div
        >
      </div>
    </div>
    <!-- 挑战信息 -->
    <div class="challenge-information">
      <div class="less-info">
        <div class="less-info-left">
          <div class="c-title">挑战目标</div>
          <div class="less-info-left-btm">
            <img class="less-icon" :src="challengeTypeIcon" alt="" />
            <div class="less-type">{{ challengeType }}</div>
          </div>
        </div>
        <div class="less-num"
          ><span>-{{ info.target }}</span
          ><span class="less-unit">{{ lessUnit }}</span></div
        >
      </div>
      <!-- 挑战结果 -->
      <div class="result-status" v-if="info.project_state">
        <img
          class="status-image"
          v-if="[3, 7].includes(info.project_state)"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/2d76666a372c3ff0a1412ff792d9af53_wh=909_153.png"
          alt=""
        />
        <img
          class="status-image"
          v-if="[4, 5, 6].includes(info.project_state)"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/01ef192502ffa0e0e883e71c74a4bd81_wh=909_153.png"
          alt=""
        />
        <div
          class="status-btn"
          v-if="[3, 7].includes(info.project_state)"
          @click="showPoster"
          >炫耀一下</div
        >
      </div>
      <div class="day-info">
        <div class="progress-container progress-container-time">
          <div
            class="progress-line"
            :style="{ width: dayProgress * 100 + '%' }"
          ></div>
        </div>
        <div class="p-text"
          ><span>时间进度：</span
          ><span class="p-num">第{{ info.day || 0 }}天</span></div
        >
      </div>
      <div class="challenge-info" v-if="info.new_value">
        <div class="progress-container">
          <div
            class="progress-line"
            :style="{ width: getchallengeProgress(challengeProgress) + '%' }"
          ></div>
        </div>
        <div class="p-text"
          ><span>挑战进度：</span
          ><span class="p-num">{{ challengeProgress }}%</span></div
        >
      </div>
      <!-- 分割线 -->
      <div class="line"></div>
      <div class="data-container" v-if="!hideData">
        <div class="data-top" :class="{ 'data-top-empty': !info.ini_value }">
          <div class="data-top-item">初始数据</div>
          <div class="data-top-item">{{
            lessNum <= 0 ? '已减少' : '已增加'
          }}</div>
          <div class="data-top-item">最新数据</div>
        </div>
        <div class="data-bottom" v-if="info.ini_value">
          <div class="data-bottom-item"
            ><span v-if="info.ini_value"
              ><span class="change-num">{{ info.ini_value }}</span
              >{{ lessUnit }}</span
            ><span v-else>-</span></div
          >
          <div class="data-bottom-item less-num-btn"
            >{{ lessNum
            }}<span class="less-num-btn-unit">{{ lessUnit }}</span></div
          >
          <div class="data-bottom-item"
            ><span v-if="info.new_value"
              ><span class="change-num">{{ info.new_value }}</span
              >{{ lessUnit }}</span
            ><span v-else>-</span></div
          >
        </div>
        <div v-else class="coach-tips">
          <div class="danger">!</div>
          <div>暂未更新最新数据，请提醒教练进行体测</div>
        </div>
        <!-- <div class="data-item">
          <div class="data-text">初始数据</div>
          <div class="data-num"><span v-if="info.ini_value">{{ info.ini_value }}{{ lessUnit }}</span><span v-else>-</span></div>
        </div>
        <div class="data-item">
          <div class="data-text">{{lessNum <= 0 ? '已减少' : '已增加'}}</div>
              <div class="data-num dat-less-num">{{ lessNum }}{{ lessUnit }}</div>
          </div>
          <div class="data-item">
            <div class="data-text">最新数据</div>
            <div class="data-num"><span v-if="info.new_value">{{ info.new_value }}{{ lessUnit }}</span><span v-else>-</span></div>
          </div> -->
      </div>
      <div class="hide-data" v-else>
        <div class="hide-left">
          <div class="hide-title">挑战成绩</div>
          <div class="hide-type">我的{{ challengeTypeName }}</div>
        </div>
        <div class="hide-right"
          ><span>{{ lessNum <= 0 ? '下降' : '上升' }}</span
          ><span class="hide-num">{{ lessNum }}</span
          >{{ lessUnit }}</div
        >
      </div>
      <!-- 训练进度 -->
      <div class="train-progress-container">
        <div class="train-title">
          <div class="train-line"></div>
          <div class="train-text">训练进度 ({{ info.class_count }}/12)</div>
          <div class="train-line"></div>
        </div>
        <div class="train-list">
          <div class="train-item" v-for="(item, index) in 12">
            <img
              class="success-image"
              v-if="index < info.class_count"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/2ab49d259530ea783c3566c1e7bad459_wh=192_192.webp"
              alt=""
            />
            <img
              class="wait-image"
              v-else
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/b5080ebe1db7c3731688665892fbbf47_wh=120_45.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false" z-index="10">
      <PreviewChallenge :info="info" @close="show = false"></PreviewChallenge>
    </van-overlay>
    <ShareComponent
      v-model="showShare"
      :poster="true"
      :posterUrl="posterUrl"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      zIndex="9999"
    />
    <PosterImageComponent
      v-model="createPoster"
      :info="info"
      @finish="bindPosterFinish"
      @fail="bindPosterFail"
    />
  </div>
</template>
<script>
import { eventObj } from '@/components/app/share/share-method.js'
import { goalData } from '../data.js'
import PreviewChallenge from './preview-challenge.vue'
import ShareComponent from '@/components/app/share/share.vue'
import PosterImageComponent from './poster-success.vue'
import html2canvas from 'html2canvas'
export default {
  components: {
    PreviewChallenge,
    ShareComponent,
    PosterImageComponent
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hideData: false,
      goalData: goalData,
      show: false,
      createPoster: false,
      showShare: false,
      posterUrl: '',
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 4
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 6
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon1',
          name: '保存到手机',
          id: 5
        }
      ]
    }
  },
  computed: {
    //挑战类型
    challengeType() {
      return (
        this.goalData.find((item) => {
          return item.id == this.info.e_type
        })?.text || ''
      )
    },
    //挑战类型名称
    challengeTypeName() {
      return (
        this.goalData.find((item) => {
          return item.id == this.info.e_type
        })?.name || ''
      )
    },
    //挑战类型图标
    challengeTypeIcon() {
      return (
        this.goalData.find((item) => {
          return item.id == this.info.e_type
        })?.icon || ''
      )
    },
    //挑战类型减少的数量
    lessNum() {
      if (!this.info?.ini_value || !this.info?.new_value) {
        return 0
      } else {
        return Number(
          (Number(this.info.new_value) - Number(this.info.ini_value)).toFixed(1)
        )
      }
    },
    lessUnit() {
      return (
        this.goalData.find((item) => {
          return item.id == this.info.e_type
        })?.unit || ''
      )
    },
    //时间进度
    dayProgress() {
      if (this.info?.day) {
        let res = this.info.day / 30
        return res > 1 ? 1 : res
      } else {
        return 0
      }
    },
    //挑战进度
    challengeProgress() {
      let res = Math.round((-this.lessNum / +this.info.target) * 100)
      return res < 0 ? 0 : res
    },
    activityStatusText() {
      //4月20日0点以后活动变为挑战结束
      let endTime = new Date(
        this.info.act_end_tiem.replace(/-/g, '/')
      ).getTime()
      let serverTime = new Date(
        this.info.server_time.replace(/-/g, '/')
      ).getTime()
      if (serverTime - endTime >= 0) {
        return '挑战结束'
      } else {
        return '挑战进行中'
      }
    }
  },
  methods: {
    bindPosterFail() {
      this.createPoster = false
    },
    bindPosterFinish() {
      this.createPoster = false
      html2canvas(document.getElementById('success-poster'), {
        backgroundColor: null,
        useCORS: true
      })
        .then((canvas) => {
          this.$toast.clear()
          this.posterUrl = canvas.toDataURL()
          this.$toast('海报已生成')
          this.showShare = true
        })
        .catch(() => {
          this.$toast.clear()
          this.$toast('生成海报出错')
        })
    },
    bindSelect(options) {
      this.showShare = false
      let shareOptions = {}
      switch (options.id) {
        case 4:
          shareOptions.url = this.posterUrl
          eventObj.shareImageToWxFriend(shareOptions)
          break
        case 5:
          eventObj.saveImageToPhone(this.posterUrl)
          break
        case 6:
          shareOptions.url = this.posterUrl
          eventObj.shareImageToWxCircle(shareOptions)
          break
      }
    },
    bindCancel() {},
    //显示海报
    showPoster() {
      this.$toast.loading('生成海报中')
      this.createPoster = true
    },
    //获取跳转进度条宽度
    getchallengeProgress(progress) {
      return progress > 100 ? 100 : progress
    },
    getHideIcon(hide) {
      return hide
        ? 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/32a576e56437ec6725642791aed1b0ad_wh=51_36.webp'
        : 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/6a2c27b1027e84534a74293e2a0a2e30_wh=45_36.webp'
    },
    bindToggle() {
      this.hideData = !this.hideData
    },
    bindClick() {
      this.$emit('confirm')
    },
    bindCancel() {
      this.$emit('cancel')
    },
    bindPreview() {
      this.show = true
    }
  }
}
</script>
<style lang="scss" scoped>
.user-container {
  background: #ffffff;
  border-radius: 12px;
  position: relative;
  margin-bottom: 26px;
  overflow: hidden;

  .toggle-btn {
    width: 96px;
    height: 28px;
    background: #181818;
    border-radius: 0px 12px 0px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 12px;
    color: #ffffff;

    .hide-icon {
      width: 17px;
      height: 12px;
      object-fit: contain;
      margin-right: 8px;
    }
  }

  .project-image {
    position: absolute;
    right: 20px;
    bottom: 18px;
    width: 76px;
    height: 16px;
  }

  .user-info {
    padding: 13px 19px 11px;
    background: #f7f7f7;
    display: flex;
    align-items: center;

    .avatar {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      object-fit: cover;
      margin-right: 10px;
    }

    .user-right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .truename {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 20px;
        color: #050b27;
        line-height: 23px;
        margin-bottom: 2px;
      }

      .user-desc {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #000000;
        line-height: 23px;

        .bold {
          text-decoration: underline;
          font-weight: bold;
          color: rgba(17, 204, 102, 1);
        }
      }
    }
  }

  .challenge-information {
    padding: 11px 19px 0px;

    .c-title {
      padding-left: 2px;
      text-align: left;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.7);
      line-height: 24px;
    }

    .less-info {
      display: flex;
      align-items: flex-end;
      margin-bottom: 6px;

      .less-info-left {
        .less-info-left-btm {
          display: flex;
          align-items: center;
        }
      }

      .less-icon {
        width: 28px;
        height: 28px;
        margin-right: 6px;
      }

      .less-type {
        white-space: nowrap;
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 22px;
        color: #000000;
      }

      .less-num {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex: 1;
        flex-shrink: 0;
        font-family: DIN, DIN;
        font-weight: bold;
        font-size: 40px;
        color: #000000;
        text-align: right;
        display: flex;
        align-items: flex-end;

        .less-unit {
          font-size: 24px;
          font-family: DIN-Bold;
        }
      }
    }

    .result-status {
      position: relative;
      margin-bottom: 3px;

      .status-image {
        width: 100%;
      }

      .status-btn {
        position: absolute;
        right: 20px;
        top: 9px;
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 12px;
        color: #11cc66;
        height: 26px;
        background: #ffffff;
        border-radius: 13px;
        display: flex;
        align-items: center;
        padding: 0px 9px;
      }
    }

    .day-info,
    .challenge-info {
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .progress-container {
        width: 190px;
        height: 10px;
        background: #f1f1f1;
        border-radius: 5px;

        .progress-line {
          width: 50px;
          height: 10px;
          background: #ea3981;
          border-radius: 5px;
        }
      }

      .progress-container-time {
        .progress-line {
          background: #11cc66;
        }
      }

      .p-text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #7e7e7e;
      }

      .p-num {
        color: #000;
        font-weight: bold;
      }
    }

    .line {
      margin-top: 10px;
      margin-bottom: 8px;
      width: 100%;
      height: 0;
      border-bottom: 1px dashed #bbbbbb;
    }

    .data-container {
      margin-bottom: 11px;

      .data-top {
        margin-bottom: 4px;
        height: 24px;
        padding: 0px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 13px;
        color: rgba(0, 0, 0, 0.7);

        .data-top-item {
        }
      }

      .data-top-empty {
        color: rgba(0, 0, 0, 0.3);
      }

      .data-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .data-bottom-item {
          height: 26px;
          max-width: 33%;
          min-width: 70px;
          text-align: center;
          font-family: DIN, DIN;
          font-weight: bold;
          font-size: 22px;
          color: #000000;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .less-num-btn {
          width: 91px;
          height: 26px;
          background: #11cc66;
          border-radius: 12px;
          font-size: 20px;
          color: #ffffff;

          .less-num-btn-unit {
            font-family: DIN-Bold;
          }
        }
      }

      .coach-tips {
        margin-top: 7px;
        height: 25px;
        background: #ffebf3;
        border-radius: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.7);

        .danger {
          width: 12px;
          height: 12px;
          background: #ea3981;
          border-radius: 50%;
          margin-right: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          font-weight: bold;
          color: #fff;
        }
      }
    }

    .hide-data {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 13px;

      .hide-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .hide-title {
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 13px;
          color: rgba(0, 0, 0, 0.7);
          line-height: 24px;
        }

        .hide-type {
          line-height: 24px;
          font-family: MiSans, MiSans;
          font-weight: bold;
          font-size: 20px;
          color: #000000;
        }
      }

      .hide-right {
        width: 146px;
        height: 31px;
        background: #11cc66;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 22px;
        color: #ffffff;

        .hide-num {
          font-family: DIN;
          font-weight: bold;
          font-size: 24px;
        }
      }
    }

    .train-progress-container {
      padding-bottom: 44px;

      .train-title {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;

        .train-line {
          flex: 1;
          height: 1px;
          background-color: #f1f1f1;
        }

        .train-text {
          white-space: nowrap;
          margin: 0px 13px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 13px;
          color: rgba(0, 0, 0, 0.7);
        }
      }

      .train-list {
        padding: 0px 4px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .train-item {
          position: relative;
          width: 64px;
          height: 64px;
          background: #f7f7f7;
          border-radius: 8px;
          margin-right: 12px;
          margin-bottom: 9px;
          display: flex;
          align-items: center;
          justify-content: center;

          .success-image {
            width: 64px;
            height: 64px;
          }

          .wait-image {
            width: 40px;
            height: 15px;
          }
        }

        .train-item:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
